// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { RadioButtonGroup } from '@carbon/react';

const StyledRadioButtonGroup = styled.div`
  position: relative;
  margin-bottom: 25px;

  &[data-invalid] .cds--form-requirement {
    display: block;
    overflow: visible;
    color: #da1e28;
    position: absolute;
    top: 100%;
  }

  .NW-TextInputWrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 5px;

    .cds--radio-button-wrapper {
      &:last-of-type {
        border-bottom: 0;
      }
      display: flex;
      align-items: center;
      width: 100%;
      padding: 15px 0;
      border-bottom: 1px solid ${ props => props.theme.products.colors.border };
      margin: 0;

      label {
        display: flex;
        align-items: center;
        font-size: 0.875rem;
        line-height: 1rem;
        color: ${ props => props.theme.colors.darkGray };
      }

      .cds--skeleton {
        margin: 0 0 0 2px !important;
        height: 20px;
        width: 150px;
      }
    }
  }
`;

const NWRadioButtonGroup = props => {
  const { className, invalid, invalidText, name, ...rest } = props;
  const theme = useTheme();

  return (
    <StyledRadioButtonGroup
      className={ className }
      data-test={ name }
      data-invalid={ invalid }
    >
      <RadioButtonGroup
        name={ name }
        { ...rest }
        theme={ theme }
        className="NW-TextInputWrapper"
      />
      { invalid && <div className="cds--form-requirement">{ invalidText }</div>}
    </StyledRadioButtonGroup>
  );
};

NWRadioButtonGroup.propTypes = RadioButtonGroup.propTypes;

export { NWRadioButtonGroup };
